import { useLang } from "../../i18n";
import { scrollTo } from "../../utils";

const Footer = () => {
  const { t } = useLang();
  const productLinks = t.products.items.map((p) => ({ label: p.name, href: p.href }));

  return (
    <footer className="border-t border-[#232733] bg-[#0A0B0E]" data-testid="footer">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#232733] border-b border-[#232733]">
        {t.footer.qualities.map((q, i) => (
          <div key={i} className="bg-[#0A0B0E] px-6 py-8">
            <div className="font-display text-base font-medium text-white tracking-tight">{q.title}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087] mt-1.5">{q.sub}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 px-6 lg:px-12 py-16">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/logo-white.png" alt="K&K Packaging" className="h-12 w-auto" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087]">Packaging</span>
          </div>
          <p className="text-sm text-[#A0AABF] mt-5 leading-relaxed max-w-xs">{t.footer.tagline}</p>
          <div className="flex flex-wrap gap-2 mt-6">
            {t.footer.badges.map((b, i) => (
              <span key={i} className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#4D8BFF] border border-[#0055FF]/30 px-3 py-1.5">
                {b}
              </span>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087]">{t.footer.productsTitle}</h4>
          <ul className="mt-5 space-y-3">
            {productLinks.map((l, i) => (
              <li key={i}>
                <button data-testid={`footer-product-${i}`} onClick={() => scrollTo(l.href)} className="text-sm text-[#A0AABF] hover:text-white transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087]">{t.footer.companyTitle}</h4>
          <ul className="mt-5 space-y-3">
            {t.footer.companyLinks.map((l, i) => (
              <li key={i}>
                <button data-testid={`footer-company-${i}`} onClick={() => scrollTo(l.href)} className="text-sm text-[#A0AABF] hover:text-white transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087]">{t.footer.contactTitle}</h4>
          <div className="mt-5 space-y-2 text-sm">
            <a href={`tel:${t.phone1.replace(/\s/g, "")}`} className="block text-[#A0AABF] hover:text-white transition-colors">{t.phone1}</a>
            <a href={`tel:${t.phone2.replace(/\s/g, "")}`} className="block text-[#A0AABF] hover:text-white transition-colors">{t.phone2}</a>
            <a href={`mailto:${t.email1}`} className="block text-[#A0AABF] hover:text-white transition-colors">{t.email1}</a>
            <p className="text-[#A0AABF]">{t.address}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4D8BFF] pt-2">{t.nav.tagline}</p>
            <div className="pt-4 border-t border-[#232733] mt-4">
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087]">{t.footer.cataloguesTitle}</span>
              <a data-testid="footer-catalogue-main" href="/assets/catalogues/KK-Catalogue-Preformes-Bouchons-Film-2026.pdf" download className="block text-sm text-[#A0AABF] hover:text-white transition-colors mt-3">
                {t.footer.catalogueMain}
              </a>
              <a data-testid="footer-catalogue-cups" href="/assets/catalogues/KK-Catalogue-Gobelets-2026.pdf" download className="block text-sm text-[#A0AABF] hover:text-white transition-colors mt-2">
                {t.footer.catalogueCups}
              </a>
              <a data-testid="footer-catalogue-main-en" href="/assets/catalogues/KK-Catalogue-Preforms-Caps-Film-2026-EN.pdf" download className="block text-sm text-[#A0AABF] hover:text-white transition-colors mt-2">
                {t.footer.catalogueMainEn}
              </a>
              <a data-testid="footer-catalogue-cups-en" href="/assets/catalogues/KK-Catalogue-Paper-Cups-2026-EN.pdf" download className="block text-sm text-[#A0AABF] hover:text-white transition-colors mt-2">
                {t.footer.catalogueCupsEn}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#232733] px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087]" data-testid="footer-copyright">
          {t.footer.copyright}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087]">{t.footer.baseline}</span>
      </div>
    </footer>
  );
};

export default Footer;
